<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 20 17">
    <g clip-path="url(#clip0_6892_9113)">
      <path
        d="M7.48371 7.96571H0.777832V1.48952H1.89548V5.92571C3.0243 2.47175 6.41077 0 10.2778 0C14.1449 0 17.6767 2.5473 18.7384 6.19555L17.6655 6.48698C16.7378 3.30286 13.6978 1.07937 10.2778 1.07937C6.66783 1.07937 3.5496 3.54032 2.77842 6.88635H7.48371V7.96571ZM13.0719 9.04508V10.1244H17.7772C17.0061 13.4705 13.8878 15.9314 10.2778 15.9314C6.85783 15.9314 3.81783 13.7079 2.89018 10.5238L1.81724 10.8152C2.87901 14.4635 6.36607 17.0108 10.2778 17.0108C14.1896 17.0108 17.5202 14.5498 18.6602 11.0959V15.5321H19.7778V9.05587H13.0719V9.04508Z"
        :class="colorClass"
      />
    </g>
    <defs>
      <clipPath id="clip0_6892_9113">
        <rect width="19" height="17" fill="white" transform="translate(0.777832)" />
      </clipPath>
    </defs>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
